import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { motion } from "framer-motion";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0C0F1C] flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md border border-zinc-800 bg-[#131A2E] p-10"
      >
        <Link to="/" data-testid="admin-login-home-link">
          <img src="/assets/osc-logo.png" alt="OSC Collision Repairs" className="h-14 w-auto" />
        </Link>
        <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mt-2 mb-10">Shop Dashboard Login</p>

        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="osc-label" htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              className="osc-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@okanaganstreetcustoms.com"
            />
          </div>
          <div>
            <label className="osc-label" htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              className="osc-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>

          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}

          <button
            type="submit"
            data-testid="admin-login-submit-button"
            disabled={loading}
            className="osc-btn-primary w-full justify-center disabled:opacity-50"
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
